const PAGE_TRACKING_FIELDS = [
	"pageName",
	"pageTitle",
	"sourceHost",
	"pageURLwp",
	"solution",
	"salesLine",
	"country",
	"templateType",
	"referrer",
	"userInterface",
	"viewportSize",
	"errorPage",
	"statusCode",
	"customerBuyable",
	"employeeBuyable",
	"selectedDeliveryMode",
	"availableDeliveryModes",
];
const USER_TRACKING_FIELDS = [
	"loggedIn",
	"userId",
	"loginType",
	"userType",
	"storeId",
	"storeName",
	"shopChannel",
	"customerTypeMshop",
];
const INTERNAL_SEARCH_TRACKING_FIELDS = [
	"query",
	"originalQuery",
	"searchType",
	"selectedSortCriteria",
	"searchPagenumber",
	"resultBrowseType",
	"favouriteResults",
	"regularResults",
	"initialSearch",
];
const EEC_TRACKING_FIELDS = ["strokePrice", "weight", "deposit", "discount"];

function makeMapping() {
	return [
		...PAGE_TRACKING_FIELDS,
		...USER_TRACKING_FIELDS,
		...INTERNAL_SEARCH_TRACKING_FIELDS,
		...EEC_TRACKING_FIELDS,
	].reduce((acc, x) => {
		acc[x] = "GA360_" + x;
		return acc;
	}, {});
}

export const GA360_MAPPING = { ...makeMapping(), language: "GA360_languageSelected" };

export const getGA360FulfillmentTypeName = function (originalName: string): string | null | undefined {
	switch (originalName.toLowerCase()) {
		case "fsd":
		case "fsd_oos":
			return "fsd";

		case "webshop":
		case "e_commerce":
		case "ecommerce":
			return "webshop";

		case "drop_shipment":
		case "dropshipment":
			return "dropShipment";

		case "marketplace":
			return "marketplace";

		case "click_and_collect":
		case "clickandcollect":
			return "clickCollect";

		case "store":
			return "store";
	}

	return null;
};
export const getGA360DeliveryModeName = function (originalName: string): string | null | undefined {
	switch (originalName.toLowerCase()) {
		case "store":
			return "store";

		case "metro_delivery":
		case "express_delivery":
		case "parcel_delivery":
			return "delivery";

		case "pickup":
			return "pickup";
	}

	return null;
};
